import { render } from "./UiStrMapping.pug?vue&type=template&id=28cffdd4&lang=pug"
import script from "./UiStrMapping.js?vue&type=script&lang=js"
export * from "./UiStrMapping.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__